import(/* webpackMode: "eager" */ "/app/apps/app/src/app/global-error.tsx");
